import PropTypes from 'prop-types';
import TextField from 'infrastructure/js/components/controls/TextField/textField';
import Validation from 'infrastructure/js/components/controls/controlsValidations.js';
import Normalize from 'infrastructure/js/components/controls/controlsNormalizations';
import GenerateButton from 'infrastructure/js/components/controls/GenerateButton/generateButton';

import './assetGenerateListItem.scss';

const maxLength100 = Validation.maxLength(100);


export default function AssetGenerateListItem({ name,
                                              index,
                                              labels,
                                              onGenerateClickCallback,
                                              maxQuantity,
                                            }) {


  const onClickCallback = () => {
    onGenerateClickCallback?.(index);
  };

  return (
    <div className='asset-generate-list-item'>
      <GenerateButton id={ name + '.[asset]'}
                      name={ name + '.[asset]'}
                      className="asset-id"
                      placeholder={labels.get('item.placeholder')}
                      validate={[Validation.required, maxLength100]}
                      onClick={onClickCallback}
                      buttonText={labels.get('item.button.generate')}
      />
      <TextField id={name + '.[quantity]'}
                 name={name + '.[quantity]'}
                 className="asset-quantity"
                 normalize={Normalize.normalizeFloat(0, parseFloat(maxQuantity))}
                 validate={Validation.required}
      />
    </div>
  )
}

AssetGenerateListItem.propTypes = {
  name: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  labels: PropTypes.object.isRequired,
  onGenerateClickCallback: PropTypes.func,
  maxQuantity: PropTypes.number,
};
